import { Check } from "lucide-react";

// Keuzetegels; opnieuw klikken maakt de keuze ongedaan (alles is optioneel).
export const ChoiceGroup = ({ name, label, options, value, onChange, cols = "grid-cols-2 sm:grid-cols-3", large = false }) => (
  <fieldset className="min-w-0">
    {label && <legend className="mb-2.5 text-[14px] font-semibold text-ink">{label} <span className="font-normal text-slate-500">(optioneel)</span></legend>}
    <div className={`grid gap-2.5 ${cols}`} role="radiogroup">
      {options.map((o) => {
        const on = value === o.id;
        return (
          <button key={o.id} type="button" role="radio" aria-checked={on} onClick={() => onChange(on ? null : o.id)}
            data-testid={`wizard-${name}-${o.id.replace(/[^a-zA-Z0-9]+/g, "-").toLowerCase()}`}
            className={`flex items-center justify-between gap-2 rounded-xl border text-left transition-[border-color,background-color,box-shadow] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-maas/40 ${
              large ? "min-h-[60px] px-4 py-3 text-[15px]" : "min-h-[48px] px-3.5 py-2.5 text-[14px]"
            } ${on ? "border-maas bg-maas-soft font-semibold text-maas-deep shadow-[0_0_0_1px_theme(colors.maas.DEFAULT)]" : "border-slate-200 bg-white text-ink hover:border-slate-300 hover:bg-slate-50"}`}>
            <span>{o.label}</span>
            <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${on ? "bg-maas text-white" : "ring-1 ring-slate-300"}`}>
              {on && <Check className="h-3.5 w-3.5" aria-hidden="true" />}
            </span>
          </button>
        );
      })}
    </div>
  </fieldset>
);
